import { differenceInCalendarDays } from "date-fns/differenceInCalendarDays";
import { endOfDay } from "date-fns/endOfDay";
import { isSameDay } from "date-fns/isSameDay";
import { startOfDay } from "date-fns/startOfDay";
import { sub } from "date-fns/sub";

/** Whole days, ending today, reaching `lookbackDays` back. */
export function rangeFromLookback(
  lookbackDays: number,
  now = new Date(),
): { fromDate: Date; toDate: Date } {
  return { fromDate: startOfDay(sub(now, { days: lookbackDays })), toDate: endOfDay(now) };
}

/** The lookback a range stands for, or `null` when it does not end today (it cannot roll). */
export function lookbackFromRange(fromDate: Date, toDate: Date, now = new Date()): number | null {
  if (!isSameDay(toDate, now)) return null;
  const days = differenceInCalendarDays(now, fromDate);
  return days >= 0 ? days : null;
}
